import { useQuery } from "react-query";
import { useFaunaContext } from "../../../providers/FaunaProvider";
import { get_performances_by_pday } from "../../../faunadb/queries/performance";

export default function usePerformancesByDay(dayId) {
    const { client } = useFaunaContext();
    return useQuery(["performances", dayId], () => get_performances_by_pday(client, dayId), { refetchOnWindowFocus: false })
}